import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { HBox, VBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';

import { COLOR_BG_LIGHT } from '../../../../vars';

const STATE = {
  addedProps: {},
  isAddSecondContact: false,
  download: true,
  sendToEmail: false,
  relation: null,
  contact: null,
  secondaryRelation: null,
  secondaryContact: null,
  extraEmail: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  strong {
    margin-bottom: 24px;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class MainModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  showModal(action) {
    this.props.sendAction(action);
  }

  reset() {
    this.props.sendAction('close');
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.bulk_actions')}
              <p className="list-result-label">{this.props.companyIds?.length}</p>
            </HBox>
          )}
          <Modal
            mobileView={this.props.mobileView}
            onClose={this.reset.bind(this)}
            title={this.lblStr('vehicle.overview.bulk_actions')}
          >
            <div className="message">
              <strong>{this.lbl('company.overview.bulk_actions.modal.title')}</strong>
            </div>

            <HBox left>
              <VBox style={{ justifyContent: 'start' }}>
                <Button onClick={() => this.showModal('showExcelModal')}>
                  {this.lbl('vehicle.overview.excel_card.share_data')}
                </Button>
              </VBox>

              <VBox style={{ justifyContent: 'start' }}></VBox>
            </HBox>

            {this.props.mobileView && (
              <ModalControls className="mobile-btn-block" style={{ backgroundColor: '#fff' }}>
                <Button className="modal-footer-button" onClick={this.reset.bind(this)}>
                  {this.lbl(`cancel`)}
                </Button>
              </ModalControls>
            )}

            {!this.props.mobileView && (
              <ModalControls style={{ justifyContent: 'end' }}>
                <Button small onClick={this.reset.bind(this)}>
                  {this.lbl(`cancel`)}
                </Button>
              </ModalControls>
            )}
          </Modal>
        </HBox>
      </Container>
    );
  }
}

MainModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const MainModal = compose(withConnect, withRouter, injectIntl)(MainModalComp);
